module.exports = __webpack_public_path__ + "static/img/subpages.65b486b0.png";